import React from 'react';
import { Button } from '@/components/ui/button';
import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = ({ testName, className = '', variant = 'default', size = 'default' }) => {
  const WHATSAPP_NUMBER = '919370209058';

  const handleWhatsAppClick = () => {
    const message = testName
      ? `Hello D-Lab,%0A%0AI would like to book the test: *${testName}*.%0A%0APlease let me know the available slots.%0A%0AThank you.`
      : `Hello D-Lab,%0A%0AI would like to know more about your diagnostic services.%0A%0APlease share the details.%0A%0AThank you.`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button
      onClick={handleWhatsAppClick}
      variant={variant}
      size={size}
      className={`shadow-primary ${className}`}
    >
      <MessageCircle className="h-4 w-4 mr-2" />
      Book on WhatsApp
    </Button>
  );
};
